module.exports = __webpack_public_path__ + "static/media/lord-jesus-christ.a5fdd883.gif";